export enum EXIT_OFFER_STATUS {
  off,
  free_trial,
  paid_trial,
}

export enum PERIOD_TYPE {
  month = 1,
  year = 2,
  day = 3,
  lifetime = 5,
  week = 6,
}

export enum MERCHANT {
  'paypal' = 22,
  'cripto' = 6,
  'paymentwall' = 4,
  'apple' = 24,
  'google' = 23,
  'paddle_billing' = 25,
  'yuno' = 26,
  // 'apple' = 27, // yuno
  // 'google' = 28, // yuno
}

export enum EXTRA_PERIOD_STATUS {
  off,
  active,
}

export type CryptoCoin = {
  crypto_currency: string;
  name: string;
  image: string;
  rate: number;
};

export type PlanBase = {
  'item-best-value-price': boolean;
  'item-currency-code': string;
  'item-currency-code-usd': string;
  'item-device-count': number;
  'item-extra-period-count': number;
  'item-extra-period-type': PERIOD_TYPE;
  'item-extra-status': EXTRA_PERIOD_STATUS;
  'item-gateways': MERCHANT[];
  'item-id': number;
  'item-offer-period-count': number;
  'item-offer-period-type': PERIOD_TYPE; // 6 = week
  'item-offer-price': number;
  'item-offer-price-usd': number;
  'item-offer-status': EXIT_OFFER_STATUS; // 0 = екзіт офер недоступний, 1 - є
  'item-package': string;
  'item-period-count': number;
  'item-period-type': PERIOD_TYPE;
  'item-price': number;
  'item-price-regular': number;
  'item-price-usd': number;
  'item-recurring-count': number;
  'item-recurring-price': number;
  'item-title': string;
};

export type MerchantFormData = {
  countryCode: string;
  domain: string;
  merchantId: string;
  merchantName: string;
  gateway: string;
  gatewayMerchantId: string;
  publicKeyId: string;
  environment: number;
  coinParams: CryptoCoin[];
  publicApiKey: string;
};

export type MerchantBase = {
  'item-active': boolean;
  'item-id': MERCHANT;
  'item-label': string;
  'item-data': MerchantFormData;
};

type InitialState = {
  email: string;
  temp_email?: string;
  page_item: string;
  plans: PlanBase[];
  gateways: MerchantBase[];
};

function getInitialState<T extends keyof InitialState>(
  prop: T,
): InitialState[T] {
  return (window.initialState as InitialState)[prop];
}

export const getUserEmail = () => getInitialState('email');
export const getTempUserEmail = () => getInitialState('temp_email');
export const getPlansList = () => getInitialState('plans');
export const getMerchantsList = () => getInitialState('gateways');
export const getPageItem = () => getInitialState('page_item') ?? '';

export function getPageItemParams() {
  return {
    page_item: getPageItem(),
  };
}
